export default {
  init() {
    $('a').each(function() {
       var a = new RegExp('/' + window.location.host + '/');
       if (!a.test(this.href)) {
           $(this).attr("target","_blank");
       }
    });
    
    
    $(".newsletter-subscribe-btn").click(function(){
      $(this).hide(); 
      $(".footer-subscribe iframe").css("opacity","1").css("position","relative").css("width","100%");;
      return false;
    });
    
    $('.block-intro-cta .content-styled > p, .block-benefits .content-styled > p, .block-benefits-with-icons .content-styled > p, .block-intro-features .content-styled > p, .block-features .content-styled > p, .block-clients .content-styled > p , .block-team .content-styled > p, .block-timeline .content-styled > p, .block-two-columns .content-styled > p, .block-cta-with-icons .content-styled > p, .block-why-choose .content-styled > p').addClass('lead');
  
    $('<div id="leadership"></div>').prependTo('#husl_block_60891f90df272');

    // Top Area
    $('.hover-area.top-area').hover(function(){
      $('.top-service').css({
        'zIndex' : 6,
        'opacity' : 1
      })
    }, function(){
      $('.top-service').css({
        'zIndex' : 1,
        'opacity': 0
      });
    });

    // Left Area
    $('.hover-area.left-area').hover(function(){
      $('.left-service').css({
        'zIndex' : 6,
        'opacity' : 1
      })
    }, function(){
      $('.left-service').css({
        'zIndex' : 1,
        'opacity': 0
      });
    });


    // Right Area
    $('.hover-area.right-area').hover(function(){
      $('.right-service').css({
        'zIndex' : 6,
        'opacity' : 1
      })
    }, function(){
      $('.right-service').css({
        'zIndex' : 1,
        'opacity': 0
      });
    });
  },
  finalize() {}
}